import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";

import { renderFieldUpload } from "../../../../Components/Forms/renders";

class SensorEditForm extends React.Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="box box-default">
        <form onSubmit={handleSubmit}>
          <div className="box-body">
            <div className="row">
              <div className="col-md-12">
                <h3>CSV bestand uploaden</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Field className="form" name="datasheet" validate={required({ msg: "Status is verplicht" })} label="Gebruik het CSV file van de stack" component={renderFieldUpload} />
              </div>
            </div>
            <div className="pull-left submit">
              <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Importeren" />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

SensorEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const ReduxFormSensorEdit = reduxForm({
  form: "sensoredit",
})(SensorEditForm);

export default connect()(ReduxFormSensorEdit);
